'use strict';

exports = module.exports = require('./dist')['default'];
exports['default'] = exports;



//////////////////
// WEBPACK FOOTER
// ../~/intl-format-cache/index.js
// module id = 657
// module chunks = 2